import type { ZmanId } from "@kedaat/engine";

type Text = { he: string; en: string };

export interface ZmanInfo {
  id: ZmanId;
  label: Text;
  /** A short column heading for tables. */
  short: Text;
  /** "pesach" zmanim are shown only on Erev Pesach. */
  group: "day" | "night" | "pesach";
}

/** All zmanim in display order. */
export const ZMANIM: readonly ZmanInfo[] = [
  {
    id: "alos",
    label: { he: "עלות השחר", en: "Dawn (Alot HaShachar)" },
    short: { he: "עלות", en: "Dawn" },
    group: "day",
  },
  {
    id: "misheyakir",
    label: { he: "משיכיר – טלית ותפילין", en: "Earliest tallit and tefillin" },
    short: { he: "משיכיר", en: "Misheyakir" },
    group: "day",
  },
  {
    id: "sunrise",
    label: { he: "הנץ החמה", en: "Sunrise" },
    short: { he: "נץ", en: "Sunrise" },
    group: "day",
  },
  {
    id: "sof_zman_shma",
    label: { he: "סוף זמן קריאת שמע", en: "Latest Shema" },
    short: { he: "ק״ש", en: "Shema" },
    group: "day",
  },
  {
    id: "sof_zman_tfila",
    label: { he: "סוף זמן תפילה", en: "Latest Shacharit" },
    short: { he: "תפילה", en: "Shacharit" },
    group: "day",
  },
  {
    id: "sof_zman_achilat_chametz",
    label: { he: "סוף זמן אכילת חמץ", en: "Latest eating chametz" },
    short: { he: "אכילת חמץ", en: "Eat chametz" },
    group: "pesach",
  },
  {
    id: "sof_zman_biur_chametz",
    label: { he: "סוף זמן ביעור חמץ", en: "Latest burning chametz" },
    short: { he: "ביעור חמץ", en: "Burn chametz" },
    group: "pesach",
  },
  {
    id: "chatzot",
    label: { he: "חצות היום", en: "Midday (Chatzot)" },
    short: { he: "חצות", en: "Chatzot" },
    group: "day",
  },
  {
    id: "mincha_gedola",
    label: { he: "מנחה גדולה", en: "Earliest Mincha" },
    short: { he: "מנחה גדולה", en: "Mincha G." },
    group: "day",
  },
  {
    id: "mincha_ketana",
    label: { he: "מנחה קטנה", en: "Mincha Ketana" },
    short: { he: "מנחה קטנה", en: "Mincha K." },
    group: "day",
  },
  {
    id: "plag_hamincha",
    label: { he: "פלג המנחה", en: "Plag HaMincha" },
    short: { he: "פלג", en: "Plag" },
    group: "day",
  },
  {
    id: "sunset",
    label: { he: "שקיעת החמה", en: "Sunset" },
    short: { he: "שקיעה", en: "Sunset" },
    group: "day",
  },
  {
    id: "tzeit",
    label: { he: "צאת הכוכבים", en: "Nightfall" },
    short: { he: "צאה״כ", en: "Nightfall" },
    group: "night",
  },
  {
    id: "tzeit_rt",
    label: { he: "צאת הכוכבים לרבנו תם", en: "Nightfall (Rabbeinu Tam)" },
    short: { he: "ר״ת", en: "R. Tam" },
    group: "night",
  },
  {
    id: "chatzot_night",
    label: { he: "חצות הלילה", en: "Midnight (Chatzot)" },
    short: { he: "חצות לילה", en: "Midnight" },
    group: "night",
  },
];
